/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia';
import { OrgsApiService } from '~packages/epk-front-shared/api-client';

export interface IOrg {
  code: number;
  landed_oktmo_code: number;
  landed_oktmo_locality: string;
  name: string;
  type_org_kk: string; // "omsu", "mou", "msh", "rou"
  phone: string;
  type_org_kk_front: string;
}

export interface IUser {
  user_is_head: boolean;
}

export interface IUserInfo {
  approved_roles: string[]; // "is_head", "omsu", "rou", "read-write", "is_no_head", "no-right"
  gen_rights_kk: string[]; // "no-right", "read-only", "read-write"
  org_choose: IOrg | null;
  location: string;
  user: IUser;
  user_fio: string;
  head?: string[];
}

export interface IStateOrg {
  as: OrgsApiService;
  userInfo: IUserInfo;
  isInited: boolean;
  isLoading: boolean;
  _queue: any[];
}

export const useOrgStore = defineStore('org', {
  state: (): IStateOrg => ({
    as: new OrgsApiService(),
    isInited: false,
    isLoading: false,
    userInfo: {
      approved_roles: [],
      gen_rights_kk: [],
      location: '',
      org_choose: null,
      user: {
        user_is_head: false,
      },
      user_fio: '',
    },
    _queue: [] as any[],
  }),
  getters: {
    orgCurrCode() {
      return this.userInfo.org_choose?.code;
    },
    isUserLeader() {
      return Boolean(this.userInfo?.user?.user_is_head);
    },
  },
  actions: {
    async init() {
      if (this.isLoading || this.isInited) {
        return new Promise(res => {
          const cb = () => res(true);
          this._queue.push(cb);
        });
      }
      this.isLoading = true;

      /*  */
      const r = await this.as.whoIm();

      if (!r.status) {
        this._queue.forEach((cb: () => void) => cb());
        this._queue.length = 0;
        this.isInited = true;
        this.isLoading = false;
        return;
      }

      this.userInfo = r.response;
      this._queue.forEach((cb: () => void) => cb());
      this._queue.length = 0;
      this.isInited = true;
      this.isLoading = false;
    },
  },
});
